import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "relative w-full bg-grey-lighten-1 overflow-y-scroll" }
const _hoisted_2 = { class: "p-4 mx-auto h-full w-full" }
const _hoisted_3 = { class: "flex justify-between items-start mb-4" }
const _hoisted_4 = { class: "text-h6 text-grey-darken-4 mb-2" }
const _hoisted_5 = { class: "text-body-1 text-grey-darken-4 d-flex align-center flex-wrap gap-2" }
const _hoisted_6 = { class: "d-flex align-center" }
const _hoisted_7 = { class: "text-grey-darken-2" }
const _hoisted_8 = {
  class: "flex flex-col items-center pt-4",
  style: {"height":"650px","overflow-y":"scroll"}
}
const _hoisted_9 = { class: "text-h4 font-weight-medium text-grey-darken-4 mb-6" }
const _hoisted_10 = { class: "flex items-center mb-6" }
const _hoisted_11 = { class: "text-h4 font-weight-medium text-grey-darken-4" }
const _hoisted_12 = { class: "w-full flex justify-center px-2" }
const _hoisted_13 = { class: "mt-6 mb-3 px-2 w-full" }
const _hoisted_14 = { class: "mt-6 mb-3 px-2 w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_TextCard = _resolveComponent("TextCard")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_TreatmentNotesCard = _resolveComponent("TreatmentNotesCard")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    class: "ad-body",
    modelValue: _ctx.dialog,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dialog) = $event)),
    scrim: false,
    "max-width": "768px",
    "onClick:outside": _ctx.closeModal,
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.name), 1),
              _createElementVNode("div", _hoisted_5, [
                _cache[6] || (_cache[6] = _createElementVNode("span", { class: "text-grey-darken-2" }, "Practitioner:", -1)),
                _createVNode(_component_v_select, {
                  modelValue: _ctx.doctorOfTreatment,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.doctorOfTreatment) = $event)),
                  items: _ctx.relatedDoctorsToTreatment,
                  id: "doctorSelect",
                  "item-title": "name",
                  "item-value": "uuid",
                  "return-object": "",
                  variant: "underlined",
                  density: "compact",
                  "hide-details": "",
                  "menu-props": {
                    maxHeight: 'auto'
                  },
                  class: "doctor-select"
                }, {
                  selection: _withCtx(({ item }) => [
                    _createElementVNode("div", {
                      class: "text-xs font-bold text-center d-inline pa-1 rounded",
                      style: _normalizeStyle({
                        backgroundColor: item.raw.color,
                        color: _ctx.$filters.foregroundColor(item.raw.color),
                        marginRight: '10px !important',
                      })
                    }, _toDisplayString(_ctx.$filters.initials(item.raw.name)), 5),
                    _createElementVNode("b", null, _toDisplayString(item.raw.name), 1)
                  ]),
                  item: _withCtx(({ item, props }) => [
                    _createVNode(_component_v_list_item, _mergeProps(props, { title: undefined }), {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("div", {
                            class: "text-xs font-bold text-center d-inline pa-1 rounded",
                            style: _normalizeStyle({
                            backgroundColor: item.raw.color,
                            color: _ctx.$filters.foregroundColor(item.raw.color),
                            marginRight: '10px !important',
                          })
                          }, _toDisplayString(_ctx.$filters.initials(item.raw.name)), 5),
                          _createElementVNode("b", null, _toDisplayString(item.raw.name), 1)
                        ])
                      ]),
                      _: 2
                    }, 1040)
                  ]),
                  _: 1
                }, 8, ["modelValue", "items"]),
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.roomName), 1)
              ])
            ]),
            _createVNode(_component_v_btn, {
              color: "grey-darken-1",
              icon: "mdi-close",
              density: "comfortable",
              variant: "text",
              onClick: _ctx.closeModal
            }, null, 8, ["onClick"])
          ]),
          _createVNode(_component_v_divider),
          _createElementVNode("div", _hoisted_8, [
            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "text-h6 text-grey-darken-2 mb-2" }, " Time Spent With Patient: ", -1)),
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.timeFormatted), 1),
            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "text-h6 text-grey-darken-2 mb-2" }, " Allocated Time ", -1)),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_TextCard, {
                class: "mr-4",
                small: "",
                text: "-1 min",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update-allocated-time', -60)))
              }),
              _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.allocatedTimeFormatted) + _toDisplayString(_ctx.allocatedOverHour ? 'm' : 's'), 1),
              _createVNode(_component_TextCard, {
                class: "ml-4",
                small: "",
                text: "+1 min",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update-allocated-time', 60)))
              })
            ]),
            _createVNode(_component_v_btn, {
              class: "text-black mb-6",
              border: "blue-300",
              disabled: 
              _ctx.cardState === 'completed' || (
                _ctx.appointment && _ctx.appointment.treatments
                  .filter(({ uuid }) => uuid !== this.treatment.uuid)
                  .some(({ started_at: a, ended_at: b }) => (!!a && !b))
              ) || _ctx.isDisabled
            ,
              icon: _ctx.stateIcon ? 'mdi-play' : 'mdi-pause',
              variant: "outlined",
              size: "large",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.togglePlayState($event)))
            }, null, 8, ["disabled", "icon"]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_v_btn, {
                class: "mr-6",
                color: "primary",
                disabled: (_ctx.cardState === 'completed') || !_ctx.treatment.started_at || _ctx.isDisabled,
                onClick: _ctx.handleCompleteTreatment
              }, {
                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                  _createTextVNode(" COMPLETE TREATMENT ", -1)
                ]))]),
                _: 1
              }, 8, ["disabled", "onClick"]),
              _createVNode(_component_v_btn, {
                class: "ml-6",
                color: "grey-darken-1",
                variant: "tonal",
                disabled: _ctx.cardState === 'default' && !_ctx.treatment.started_at || _ctx.isDisabled,
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('reset-treatment')))
              }, {
                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                  _createTextVNode(" RESET ", -1)
                ]))]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _cache[11] || (_cache[11] = _createElementVNode("div", null, [
                _createElementVNode("p", { class: "flag-title mb-2" }, "TYPES AND FLAGS")
              ], -1)),
              _createElementVNode("div", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentOpenFlags, (flag, index) => {
                  return (_openBlock(), _createBlock(_component_v_chip, {
                    key: `treatment-flags-${index}`,
                    class: "mr-2 mb-2 flags"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.appointment.has_flags)
                        ? (_openBlock(), _createBlock(_component_v_icon, {
                            key: 0,
                            color: "red-darken-2",
                            size: 18
                          }, {
                            default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                              _createTextVNode("mdi-flag", -1)
                            ]))]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(`${flag.message}${flag.description ? `: ${flag.description}` : ''}`), 1)
                    ]),
                    _: 2
                  }, 1024))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentOpenTractionFlags, (tFlag, index) => {
                  return (_openBlock(), _createBlock(_component_v_chip, {
                    key: `treatment-t-flags-${index}`,
                    class: "mr-2 mb-2 tFlags"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        color: "green-darken-2",
                        size: 18
                      }, {
                        default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                          _createTextVNode("mdi-flag", -1)
                        ]))]),
                        _: 1
                      }),
                      _createTextVNode(" " + _toDisplayString(`${tFlag.message}${tFlag.description ? `: ${tFlag.description}` : ''}`), 1)
                    ]),
                    _: 2
                  }, 1024))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentOpenProfiles, (profile, index) => {
                  return (_openBlock(), _createBlock(_component_v_chip, {
                    key: `treatment-profiles-${index}`,
                    class: "mr-2 mb-2 types"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(profile.name), 1)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _cache[12] || (_cache[12] = _createElementVNode("div", null, [
                _createElementVNode("p", { class: "flag-title mb-2" }, "NOTES")
              ], -1)),
              _createElementVNode("div", null, [
                _createVNode(_component_TreatmentNotesCard, {
                  notes: _ctx.currentGlobalNotes,
                  "appt-treatment-id": _ctx.treatment.uuid,
                  "appointment-id": _ctx.appointment.uuid,
                  "patient-id": _ctx.appointment.patient.uuid,
                  "patient-name": _ctx.appointment.patient.name,
                  "treatment-name": `Global`,
                  "hide-patient": "",
                  onRefreshNotes: _ctx.refreshAppointment,
                  onSetAllowedClose: _ctx.setAllowedToClose
                }, null, 8, ["notes", "appt-treatment-id", "appointment-id", "patient-id", "patient-name", "onRefreshNotes", "onSetAllowedClose"]),
                _createVNode(_component_TreatmentNotesCard, {
                  "hide-patient": "",
                  notes: _ctx.currentLocalNotes,
                  "appt-treatment-id": _ctx.treatment.uuid,
                  "treatment-id": _ctx.treatment.treatment.uuid,
                  "appointment-id": _ctx.appointment.uuid,
                  "patient-id": _ctx.appointment.patient.uuid,
                  "patient-name": _ctx.appointment.patient.name,
                  "treatment-name": _ctx.treatment.treatment.name,
                  onRefreshNotes: _ctx.refreshAppointment,
                  onSetAllowedClose: _ctx.setAllowedToClose
                }, null, 8, ["notes", "appt-treatment-id", "treatment-id", "appointment-id", "patient-id", "patient-name", "treatment-name", "onRefreshNotes", "onSetAllowedClose"])
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "onClick:outside"]))
}